import styled, { StyledComponent } from '@emotion/styled';
import { Grid, Theme } from '@prometheus/components';

export const LogoContainer: StyledComponent<any> = styled(Grid)(
  (props: { theme: Theme }) => ({
    backgroundColor: props.theme.palette.primary.main,
    boxShadow: props.theme.customShadows[0],
    zIndex: 1,
  })
);

export const LoginFormContainer: StyledComponent<any> = styled(Grid)(
  (props: { theme: Theme }) => ({
    backgroundColor: props.theme.palette.backgroundColor.dark,
    alignItems: 'center',
    display: 'flex',
  })
);

export const WelcomeText: StyledComponent<any> = styled(Grid)`
  font-size: 14px;
  color: #aaaaaa;
`;

export const LoginFormHeader: StyledComponent<any> = styled(Grid)`
  font-size: 24px;
  color: #424242;
  font-weight: 300;
`;

export const FormControl: StyledComponent<any> = styled(Grid)`
  label {
    color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
    font-weight: 700;
    width: 130px;
    display: block;
    font-size: 12px;
    margin-bottom: 5px;
  }
`;

export const Divider = styled.div`
  display: block;
  border-top: 1px solid ${({ theme }: any) => theme.palette?.borderColor.main};
  margin-bottom: 16px;
`;

export const CorporatePolicyText = styled.p`
  color: ${({ theme }: any) => theme.palette.textColor.label};
  font-size: 14px;
`;

export const CorporatePolicyLink = styled.a`
  color: ${({ theme }: any) => theme.palette.primary.main};
  font-weight: bold;
`;
